<template>
  <span class="hc-badge" :class="`hc-badge--${variant}`"><slot /></span>
</template>

<script>
export default {
  name: "HcBadge",
  props: { variant: { type: String, default: "primary" } },
};
</script>
